import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_soft_coconut.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganSoftCoconutBun() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Soft Coconut Bun",
    content_category: "Vegan Menu",
    content_ids: ["vegan_soft_coconut_bun"],
    content_type: "vegan_vietnamese_pastries",
    value: 4.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Soft Coconut Bun | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Soft, flaky layers wrap around a creamy coconut center that's comforting, clean, and never overly sweet."
        />
        <meta
          property="og:title"
          content="Vegan Soft Coconut Bun | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Soft, flaky layers wrap around a creamy coconut center that's comforting, clean, and never overly sweet."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN SOFT COCONUT BUN"
          titleSubHead="$4.00 each"
          detailBody="Soft, flaky layers wrap around a creamy coconut center that's comforting, clean, and never overly sweet."
          detailBodyBr="Contains: wheat"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganSoftCoconutBun;